import { useMutation } from '@tanstack/react-query';

import { getAttachmentsByIdAccessUrl } from '@/api/generated/attachments/attachments';
import { GetAttachmentsByIdAccessUrlDisposition } from '@/api/generated/lucioAPI.schemas';

/**
 * Mint a short-lived Azure SAS URL for an attachment, baked with the
 * requested Content-Disposition. Use 'inline' for in-browser preview
 * (e.g. PDF in viewer) and 'attachment' to trigger a download.
 *
 * Wraps the generated query function in a mutation so callers can invoke
 * it imperatively (e.g. on click) rather than reactively on mount.
 */
export const useGetAttachmentAccessUrl = () => {
  return useMutation({
    mutationFn: async ({
      disposition,
      id,
    }: {
      disposition: 'inline' | 'attachment';
      id: string;
    }): Promise<string> => {
      const response = await getAttachmentsByIdAccessUrl(id, {
        disposition: GetAttachmentsByIdAccessUrlDisposition[disposition],
      });
      return response.url;
    },
    retry: 1,
    retryDelay: 1000,
  });
};
